import React, { Component } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import { CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;

class DateRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateTo: this.props.dateTo ? dayjs(this.props.dateTo) : dayjs(),
      dateFrom: this.props.dateFrom ? dayjs(this.props.dateFrom) : dayjs(),
    };
  }

  componentDidMount() {
    const { dateTo, dateFrom } = this.props;
    if (dateTo && dateFrom) {
      this.setState({
        dateTo: dayjs(dateTo),
        dateFrom: dayjs(dateFrom),
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dateTo !== this.props.dateTo || prevProps.dateFrom !== this.props.dateFrom) {
      this.setState({
        dateTo: dayjs(this.props.dateTo),
        dateFrom: dayjs(this.props.dateFrom),
      });
    }
  }

  onChangeDate = (dates, dateStrings) => {
    this.setState({
      dateTo: dates[1],
      dateFrom: dates[0],
    });

    this.props.onselectChanges({
      id: this.props.selectdata.name,
      text: dateStrings,
      name: this.props.selectdata.name,
      value: dateStrings,
      parrentMode: this.props.selectdata.parrentMode,
      parrentName: this.props.selectdata.parrentName,
    });
  };

  disabledDate = current => {
    return current && this.props.selectdata.name !== "booking_request_report" && current > dayjs();
  };

  render() {
    const { dateTo, dateFrom } = this.state;
    const { selectdata } = this.props;

    return (
      // <RangePicker
      //   format="DD-MMM-YYYY"
      //   allowClear={false}
      //   disabledDate={this.disabledDate}
      //   inputReadOnly={true}
      //   placeholder={['Start Date', 'End Date']}
      //   value={[dateFrom, dateTo]}
      //   onChange={this.onChangeDate}
      // />
      // <RangePicker
      // value={[moment(dateFrom), moment(dateTo)]}
      //  />
      <div>
      <RangePicker
      suffix={CalendarOutlined }
      value={[dayjs(dateFrom, 'YYYY-MM-DD'), dayjs(dateTo, 'YYYY-MM-DD')]}
      defaultValue={[dayjs(dateFrom, 'YYYY-MM-DD'), dayjs(dateTo, 'YYYY-MM-DD')]}
      disabledDate={this.disabledDate}
      disabled={[false, false]}
      allowClear={false}
      // suffixIcon={false}
      onChange={this
        .onChangeDate
        .bind(this)}
    /></div>
    );
  }
}

export default DateRange;
